import { Toaster as Sonner } from "sonner";

export function Toaster() {
  return (
    <Sonner
      theme="dark"
      position="bottom-center"
      toastOptions={{
        classNames: {
          toast:
            "bg-popover-opaque border border-border text-foreground shadow-md rounded-md font-sans",
          title: "text-sm font-medium text-foreground",
          description: "text-sm font-normal text-muted-foreground",
          actionButton:
            "bg-primary/15 text-primary border border-primary/50 hover:bg-primary/25 text-xs font-normal px-3 py-1 rounded-md",
          cancelButton:
            "text-muted-foreground hover:text-foreground text-xs font-normal px-3 py-1 rounded-md",
          closeButton:
            "text-muted-foreground hover:text-foreground border-border hover:bg-foreground/10",
          success: "border-success/30 [&>[data-icon]]:text-success",
          error: "border-destructive/30 [&>[data-icon]]:text-destructive",
          warning: "border-warning/30 [&>[data-icon]]:text-warning",
          info: "border-info/30 [&>[data-icon]]:text-info",
        },
      }}
    />
  );
}
